import { ICommonView } from "./ICommonView";
import { Ref, ref } from "vue";
import { IMessageLogic } from "./IMessageLogic";
import { ILoadingLogic } from "./ILoadingLogic";
import { Message } from "./Message";

/**
 * 画面共通処理
 */
export class CommonView implements ICommonView {
  /**
   * メッセージ連携変数
   */
  _messageObject: Ref<
    {
      message: Message;
      multiButtonFlg: boolean;
      confirmCallBack: () => void;
      cancelCallBack: () => void;
    }[]
  > = ref([]);

  /**
   * ローディング表示状態
   */
  _isDispLoading = ref(false);

  /**
   * メッセージ処理
   */
  _messageLogic: IMessageLogic = {
    /**
     * メッセージ表示
     */
    onOpenMessage: (
      message: Message,
      multiButtonFlg?: boolean,
      confirmCallBack?: () => void,
      cancelCallBack?: () => void
    ) => {
      this._messageObject.value.push({
        message: message,
        multiButtonFlg: multiButtonFlg ? multiButtonFlg : false,
        confirmCallBack: confirmCallBack ? confirmCallBack : null,
        cancelCallBack: cancelCallBack ? cancelCallBack : null,
      });
    },

    /**
     * メッセージを閉じる
     */
    onCloseMessage: (index: number) => {
      this._messageObject.value.splice(index, 1);
    },
  };

  /**
   * ローディング処理
   */
  _loadingLogic: ILoadingLogic = {
    /**
     * ローディング表示
     */
    onOpenLoading: () => {
      this._isDispLoading.value = true;
    },

    /**
     * ローディングを閉じる
     */
    onCloseLoading: () => {
      this._isDispLoading.value = false;
    },
  };
}
